<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="/" aria-label="Go to home page"
            ><i class="fa fa-home"></i>Home
          </a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          {{ folderName }}
        </li>
      </ol>
    </nav>
    <div class="card">
      <div class="card-header">
        <div class="card-title">Radiation Records</div>
      </div>
      <div class="card-body">
        <div v-if="impersonationShowComputed" class="impersonation-email">
          <div class="input-group">
            <input
              type="text"
              v-model="email"
              class="form-control text-capitlalize"
              placeholder="crew's email"
              @keyup="toLower"
            />
            <div class="input-group-append">
              <span class="input-group-text">{{ emailDomain }}</span>
            </div>
            <button
            type="button"
            class="btn btn-secondary"
            aria-label="search"
            @click="retrieveRadiation"
            >
              Search
            </button>
          </div>
        </div>
        <form class="form-row">
          <div class="col-md">
            <table class="col-12 text-grey text-center">
              <tr>
                <th>Month</th>
                <th>Value(mSv)</th>
              </tr>
              <tr v-for="(radiation, idx) in radiationRecords" :key="idx">
                <td>{{ $moment(radiation.month).format("MMM YYYY") }}</td>
                <td v-if="radiation.radiationValue > 0">{{ radiation.radiationValue }}</td>
                <td v-else>-</td>
              </tr>                        
              <tr class="font-weight-bold">
                <td>Total</td>
                <td>{{ accumulatedValue(radiationRecords) }}</td>
              </tr>
            </table>
            <h6 class="warning text-center text-grey">
              To align with the Nuclear Safety Committee's promotion of the 
              "Cosmic Radiation Dose Management Trial Program for Flight Crew," 
              we will provide flight crew members with the assessment results of 
              their monthly and accumulated flight doses. 
              This trial program will be implemented from January 1, 2025, 
              and will continue until December 31, 2025.
            </h6>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data: () => ({
    emailDomain: '@starlux-airlines.com',
    folderName: '',
    email: '', //unknown
    radiationRecords:[],
    searchMail: localStorage.getItem("mail"),
  }),
  computed: {
    impersonationShowComputed() {
      return this.$store.getters.isImpersonation;
    },
    originalMailOrNot() {
      if (this.impersonateMail != "") {
        return this.impersonateMail === localStorage.getItem("mail");
      } else {
        return true;
      }
    }
  },
  methods: {
    async retrieveRadiation(){
      this.searchMail = this.email
          ? this.email + this.emailDomain
          : localStorage.getItem('mail');
      this.getRadiation(localStorage.getItem("access_token"), this.searchMail)
        .then(resp => {
          console.log(resp);
          this.radiationRecords = resp.data.data;
        })
        .catch(err => {
          console.log("err", err);
          this.radiationRecords = [];
        });
    },
    accumulatedValue(value){
      let total = 0;
      value.forEach(item => {
        total += item.radiationValue;
      });
        return total;
    },
    toLower(val) {
      this.email = val.target.value.toLowerCase();
    }
  },
  async created() {
    this.folderName = this.$route.name;
  },
  async mounted() {
    await this.retrieveRadiation();
  }
};
</script>

<style lang="scss" scoped>
.input-group-text {
  font-size: 14px;
}
.warning{
  margin-top: 12px;
}
.impersonation-email{
  margin-bottom: 12px;
}
.card-title{
  text-transform: capitalize;
}
</style>
